import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';

const subscribe = (notify: () => void) => {
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
  return () => {
    window.removeEventListener('online', notify);
    window.removeEventListener('offline', notify);
  };
};

/** docs/08 §10: banner fijo arriba mientras no hay conexión. */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useSyncExternalStore(subscribe, () => navigator.onLine);
  if (online) return null;
  return (
    <div className="banner p-warn" role="status" style={{ borderRadius: 0 }}>
      {t('common.offline')}
    </div>
  );
}
